let wse = ''

switch (process.env.NODE_ENV) {
    case 'production':
        // wse = 'wss://www.najiaqingyimei.com/ws'
        wse = ''
        break
    default:
        wse = ''
        // wse = 'ws://localhost:3503/ws'
        break
}

export const wsEndpoint = wse

export const wxapp = {
    originalId: 'gh_4d2528418792',
    // appid: 'wx8ac8d7ec62aba0fd', // 测试
    appid: 'wxd5dff8dad748be0c',
    name: '火力全开',
    qrcode: '/rifeng/20210602/03ee39bdb84ec99eca3f9837b9f26c8e.jpg?rnd=531028'
}

export const resourceServer = {
    qiniu: 'https://qnoss.hlqk.net/',
    // qiniu2: 'https://cdn.zhenxianguo88.com',
    // apiUrl: 'https://mallqas.rifeng.com.cn'
    apiUrl: 'https://mall.rifeng.com.cn'
    // local: 'https:/www.najiaqingyimei.com/resources'
}
export default { wxapp, resourceServer, wsEndpoint }



// WEBPACK FOOTER //
// ./src/config/config.js